import { useTranslation } from 'react-i18next'

import { lightPalette } from '../palette'
import { Eyebrow } from './Eyebrow'

export function ProductHighlights() {
  const { t } = useTranslation()

  const stats = [
    {
      value: t('landing.product.stat1Value'),
      title: t('landing.product.stat1Title'),
      desc: t('landing.product.stat1Desc'),
    },
    {
      value: t('landing.product.stat2Value'),
      title: t('landing.product.stat2Title'),
      desc: t('landing.product.stat2Desc'),
    },
    {
      value: t('landing.product.stat3Value'),
      title: t('landing.product.stat3Title'),
      desc: t('landing.product.stat3Desc'),
    },
    {
      value: t('landing.product.stat4Value'),
      title: t('landing.product.stat4Title'),
      desc: t('landing.product.stat4Desc'),
    },
  ]

  return (
    <section id="produto" style={{ maxWidth: 1200, margin: '0 auto', padding: '96px 24px 24px' }}>
      <div
        data-reveal=""
        style={{ display: 'flex', flexDirection: 'column', gap: 14, maxWidth: 680 }}
      >
        <Eyebrow>{t('landing.product.eyebrow')}</Eyebrow>
        <h2
          style={{
            margin: 0,
            fontSize: 'clamp(30px,3.6vw,44px)',
            lineHeight: 1.08,
            fontWeight: 600,
            letterSpacing: '-0.035em',
            textWrap: 'balance',
          }}
        >
          {t('landing.product.title')}
        </h2>
        <p style={{ margin: 0, fontSize: 17, lineHeight: 1.6, color: lightPalette.textBody }}>
          {t('landing.product.subtitle')}
        </p>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(250px,1fr))',
          gap: 18,
          marginTop: 44,
        }}
      >
        {stats.map((stat) => (
          <div
            key={stat.title}
            data-reveal=""
            style={{
              border: `1px solid ${lightPalette.borderDefault}`,
              borderRadius: 16,
              background: lightPalette.surface,
              padding: 26,
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
            }}
          >
            <span
              style={{
                fontSize: 26,
                fontWeight: 800,
                letterSpacing: '-0.02em',
                color: lightPalette.brandAccent,
              }}
            >
              {stat.value}
            </span>
            <span style={{ fontSize: 16, fontWeight: 700 }}>{stat.title}</span>
            <span style={{ fontSize: 14, lineHeight: 1.6, color: lightPalette.textBody }}>
              {stat.desc}
            </span>
          </div>
        ))}
      </div>
    </section>
  )
}
